export default "../css/10c8d41b7db4d4e5e68b17d3c5720f53.ttf";